import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubCourseDetails from './Subcomponents/CourseDetails';
import withRouter from './Functions/WithRouter';

class AdvCourseDetails extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";
      console.log('just mounted daddy log in adv')

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let username = localStorage.getItem('username');
      let activeOrg = localStorage.getItem('activeOrg');
      let orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      const { id} = this.props.params
      this.setState({ activeOrg, emailId: email, username, orgFocus, roleName, orgLogo, id });

    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called within parentCourseDetails ', this.props, prevProps)

      if (this.props.params && this.props.params.id !== prevProps.params.id) {
        console.log('new course selected in parent')
        this.setState({ id: this.props.params.id })
      }
    }

    render() {

      return (
          <div>
              <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />
              <SubCourseDetails courseId={this.state.id} history={this.props.navigate}/>

              <div className="clear" />

              {(this.state.activeOrg) && (
                <div>
                  {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
                </div>
              )}
          </div>

      )
    }
}

export default withRouter(AdvCourseDetails);
